export const IdentityCustomerInputKey = '__id_data__';
